import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 1px;

  & svg {
    width: 100%;
    height: 100%;
  }

  & span:last-of-type {
    position: absolute;
    top: -6px;
    right: -6px;

    @media (width >= 48rem) {
      top: -8px;
      right: -8px;
    }
  }
`;
